import type { IFinancialCockpitActualsAndTargetsSetting } from '../api/types'
import type { ICockpitSubCategoryOption, TCockpitSubCategoriesByCategory } from '../model/types'

export const getCockpitSubCategoriesByCategory = (
  settings: IFinancialCockpitActualsAndTargetsSetting[]
): TCockpitSubCategoriesByCategory => {
  const subCategoriesByCategory = new Map<string, Map<string, ICockpitSubCategoryOption>>()

  settings.forEach(({ Category, SubCategory, SubCategoryOrder, IsMainHierarchy }) => {
    const category = Category.trim()
    const subCategory = SubCategory.trim()

    if (!category || !subCategory || IsMainHierarchy !== 1) {
      return
    }

    const subCategories = subCategoriesByCategory.get(category) ?? new Map()
    const existingSubCategory = subCategories.get(subCategory)

    if (!existingSubCategory || SubCategoryOrder < existingSubCategory.order) {
      subCategories.set(subCategory, { subCategory, order: SubCategoryOrder })
    }

    subCategoriesByCategory.set(category, subCategories)
  })

  return Object.fromEntries(
    Array.from(subCategoriesByCategory, ([category, subCategories]) => [
      category,
      Array.from(subCategories.values()).sort(
        (left, right) =>
          left.order - right.order || left.subCategory.localeCompare(right.subCategory)
      ),
    ])
  ) as TCockpitSubCategoriesByCategory
}
